import { ICreateProductMaskOptionPayload } from '../../Services/api/product-mask-options/product-mask-options.interface'
import { ProductMaskOptionsApiRemoteService } from '../../Services/api/product-mask-options/product-mask-options-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'

export class CreateProductMaskOptionUseCase
implements IFormUsecase<ICreateProductMaskOptionPayload, void> {
  constructor(private readonly ProductMaskOptionsApi: ProductMaskOptionsApiRemoteService) {}

  public async handle(data: ICreateProductMaskOptionPayload): Promise<Result<void>> {
    try {
      return await this.ProductMaskOptionsApi.create(data)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
